export const CERTIFICATES_TYPES = {
  'Elige una opción': '',
  CIUDADANO: 'citizens',
  PATRIMONIAL: 'properties',
  EMPRESARIAL: 'business',
};
export const CERTIFICATES_OPTIONS = {
  citizens: { CURP: 'curp', RFC: 'rfc' },
  properties: {
    'CLAVE CATASTRAL': 'claveCatastral',
    'FOLIO REGISTRAL': 'folioRegistral',
    CURP: 'curp',
    RFC: 'rfc',
  },
  business: { RFC: 'rfc', 'FOLIO MERCANTIL': 'folioMercantil' },

  // 'CIUDADANO':['curp','rfc'],
  // 'PATRIMONIAL':['claveCatastral','folioRegistral','curp','rfc'],
  // 'EMPRESARIAL':['rfc','folioMercantil'],
};
export const CERTIFICATES_PLACEHOLDER = {
  curp: 'Ingresa la curp',
  rfc: 'Ingresa el rfc',
  claveCatastral: 'Ingresa la clave catastral',
  folioRegistral: 'Ingresa el folio registral',
  folioMercantil: 'Ingresa el folio mercantil',
};

export const CERTIFICATES_TYPES_ARRAY = ['citizens', 'properties', 'business'];
export const ENUM_CERTIFICATES_TYPES = {
  citizens: 'citizens',
  properties: 'properties',
  business: 'business',
};
export const CERTIFICATES_TYPES_TRANSLATED = {
  citizens: 'Ciudadano',
  properties: 'Patrimonial',
  business: 'Empresarial',
};
export const CERTIFICATES_TYPES_TRANSLATED_TYPE = {
  ciudadano: 'citizens',
  patrimonial: 'properties',
  empresarial: 'business',
};
///curp=18-letras y numeros

export const CERTIFICATES_TYPES_TRANSLATED_TITLE = {
  ciudadano: 'Expediente Único Ciudadano',
  patrimonial: 'Expediente Patrimonial',
  empresarial: 'Expediente Único Empresarial',
};

// export const CERTIFICATES_TITLE_SELECT_TABLE = {
//     'all': 'Todos los certificados',
//     'ciudadano': 'Expediente Único Ciudadano',
//     'patrimonial': 'Expediente Patrimonial',
//     'empresarial': 'Expediente Único Empresarial'
// }

export const CERTIFICATES_TITLE_SELECT_TABLE = [
  {
    key: '',
    value: 'Todos los certificados',
  },
  { key: 'ciudadano', value: 'Expediente Único Ciudadano' },
  { key: 'patrimonial', value: 'Expediente Patrimonial' },
  {
    key: 'empresarial',
    value: 'Expediente Único Empresarial',
  },
];

export const CERTIFICATES_STATUS = [
  {
    key: '',
    value: 'Todos los estados',
  },
  {
    key: 'VIGENTE',
    value: 'VIGENTE',
  },
  {
    key: 'VENCIDO',
    value: 'VENCIDO',
  },
  {
    key: 'REVOCADO',
    value: 'REVOCADO',
  },
];
